/*
 *
 * CollaboratorsEdit actions
 *
 */

import {
  GET_COLLABORATOR_INFO_WATCHER,
  GET_COLLABORATOR_INFO_SUCCESS,
  GET_COLLABORATOR_INFO_FAILED,
  UPDATE_COLLABORATOR_WATCHER,
  UPDATE_COLLABORATOR_SUCCESS,
  REMOVE_COLLABORATOR_WATCHER,
  REMOVE_COLLABORATOR_SUCCESS,
  GET_MEASURES_WATCHER,
  GET_MEASURES_SUCCESS,
  GET_MEASURES_FAILED,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
} from "./constants"

// GET LANGAUGE
export function getLanguageWatcher(payload) {
  return {
    type: GET_LANGUAGE_WATCHER,
    payload,
  }
}

export function getLanguageSuccess(payload) {
  return {
    type: GET_LANGUAGE_SUCCESS,
    payload,
  }
}

export function getLanguageFailed(payload) {
  return {
    type: GET_LANGUAGE_FAILED,
    payload,
  }
}
export const updateCollaboratorWatcher = (payload) => {
  return {
    type: UPDATE_COLLABORATOR_WATCHER,
    payload,
  }
}

export const updateCollaboratorEnd = () => {
  return { type: UPDATE_COLLABORATOR_SUCCESS }
}

export const getCollaboratorData = (payload) => {
  return {
    type: GET_COLLABORATOR_INFO_WATCHER,
    payload,
  }
}

export const getCollaboratorSuccess = (payload) => {
  return {
    type: GET_COLLABORATOR_INFO_SUCCESS,
    payload,
  }
}

export const getCollaboratorFailed = () => {
  return { type: GET_COLLABORATOR_INFO_FAILED }
}

export const removeCollaboratorWatcher = (payload) => {
  return {
    type: REMOVE_COLLABORATOR_WATCHER,
    payload,
  }
}

export const removeCollaboratorSuccess = () => {
  return { type: REMOVE_COLLABORATOR_SUCCESS }
}

// GET MEASURES
export function getMeasuresWatcher(payload) {
  return {
    type: GET_MEASURES_WATCHER,
    payload,
  }
}

export function getMeasuresSuccess(payload) {
  return {
    type: GET_MEASURES_SUCCESS,
    payload,
  }
}

export function getMeasuresFailed(payload) {
  return {
    type: GET_MEASURES_FAILED,
    payload,
  }
}
